// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2EkhB","footer":"ReportModalFilter_footer__dEWiU"};